import styled from 'styled-components';

const ShopAnchor = styled.a`
  display: inline-block;
  background-color: #000;
  border: 1px solid #000;
  border-radius: 5px;
  color: white;
  font-size: 15px;
  letter-spacing: 1px;
  outline: none;
  text-decoration: none;
  text-transform: uppercase;
  user-select: none;
  transition: all 0.25s ease-in-out;
  margin: ${props => (props.margin ? props.margin : '0%')};
  width: ${props => (props.width ? props.width : '100%')};
  line-height: 38px;
  text-align: center;
  font-weight: bold;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  
  &:hover {
    color: white;
    text-decoration: none;
  }
`;

export default ShopAnchor;
